import React from 'react'

export const DetailUser = () => {
  return (
    <div>Detail</div>
  )
}
